import { CheckboxField } from '@hypeit-gmbh/hypeit-ui';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'EDIT_COMPANY_LINK_FORM.EXCLUDE_FROM_CONFIRMATION_MAIL';

export const ExcludeFromConfirmationMail: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <CheckboxField
      fieldName="excludeFromConfirmationMails"
      label={t(`${TRANS_PATH}.LABEL`)}
    />
  );
};
